import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({ open, title, message, confirmText = 'Delete', cancelText = 'Cancel', loading = false, onConfirm, onCancel }) => {
  if (!open) return null;

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <div className="confirm-modal-header">
          <h3>{title}</h3>
        </div>
        <div className="confirm-modal-body">
          <p>{message}</p>
        </div>
        <div className="confirm-modal-actions">
          <button className="confirm-btn cancel" onClick={onCancel} disabled={loading}>{cancelText}</button>
          <button className="confirm-btn confirm" onClick={onConfirm} disabled={loading}>
            {loading ? 'Deleting...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
